import { Link } from 'react-router-dom';

export function NotFoundView() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center">
      <div className="text-center">
        <h2 className="text-lg font-semibold text-foreground">Page not found</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          That route does not exist in this portal.
        </p>
        <Link
          to="/leadloop"
          className="mt-4 inline-block text-sm font-medium text-primary hover:underline"
        >
          Back to LeadLoop
        </Link>
      </div>
    </div>
  );
}
